import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';

import { EAction } from '~/src/features/internetV2/constants/actions';
import { IAction } from '~/src/store';

const setRouters = (payload: IEquipment[]): IAction<EAction.SetRouters, IEquipment[]> => ({
    type: EAction.SetRouters,
    payload,
});

export default setRouters;
